import $ from 'jquery';
import Swal from 'sweetalert2';

const errorHtml = `
    <div class="container editor-loader-menu-containers" id="container-error">
        <div class="row">
            <div class="col-md-12">
                <h1>Oops, si &egrave; verificato un errore</h1>
                <h2>Ti preghiamo di riprovare</h2>
            </div>
        </div>

        <div class="row" id="editor-servizio"></div>
    </div>
`;

export const setErrorHandler = () => {
  window.onerror = function (msg, url, lineNo, columnNo, error) {
    console.error({ msg, url, lineNo, columnNo, error });
    $('#editor-main-menu').html(errorHtml);
    return false;
  };
};

export const onCanvasNotFound = () => {
  Swal.fire({
    icon: 'error',
    title: 'Oops',
    text: 'Non è stato possibile caricare ll progetto che stai cercando.',
    confirmButtonColor: '#278e8e',
  });
};

export const genericSuccess = (title, text) => {
  Swal.fire({
    title: title,
    text: text,
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};

export const onErrorShowMessage = async (reload = false, opts) => {
  await Swal.fire({
    icon: 'error',
    title: 'Oops',
    text: 'Si è verificato un errore. Si prega di riprovare.',
    confirmButtonColor: '#278e8e',
    ...opts,
  });

  if (reload) {
    location.reload();
  }
};
